import DefaultValidation from '@/services/validations/DefaultValidation';
import * as Util from '@/functions/Util';

export default class RecomendacaoValidation extends DefaultValidation {
	validate(model, permissao, refs) {
		let validated = true;

		if (Util.isNull(model.idagro_tiporecomendacao)) {
			refs.tiporecomendacaoSelect.focusedOut = true;
			validated = false;
		}
		if (permissao.ativaproduto==2&&Util.isNull(model.idproduto)) {
			refs.produtoSelect.focusedOut = true;
			validated = false;
		}
    if (permissao.ativadosagem==2&&model.dosagem==0) {
			refs.dosagemInput.focusedOut = true;
			validated = false;
		}
    if (permissao.ativapressaobico==2&&model.pressaobicos==0) {
			refs.pressaobicosInput.focusedOut = true;
			validated = false;
		}
    if (permissao.ativaqtde==2&&model.qtde==0) {
			refs.qtdeInput.focusedOut = true;
			validated = false;
		}
    if (permissao.ativaformaaplicacao==2&&Util.isNull(model.formaaplicacao)) {
			refs.formaaplicacaoTextarea.focusedOut = true;
			validated = false;
		}
    if (permissao.ativadescricaogeral==2&&Util.isNull(model.observacao)) {
			refs.observacaoTextarea.focusedOut = true;
			validated = false;
		}

		return validated;
	}
}